import { Box, Typography } from '@mui/material';
import { Dayjs } from 'dayjs';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../../components/Button/Button';
import { LANG_TEXT } from '../../../../constants/language';
import { ButtonStyle } from '../../styles';
import TimeBox from './TimeBox';

interface CalendarControlsProps {
  selectedDate: Dayjs | null;
  gameStartTime: string;
  deliveryStartTime: string;
  onPreOrdersClick: () => void;
  onEditClick: () => void;
  hasSchedule?: boolean;
}

export const CalendarControls: React.FC<CalendarControlsProps> = ({
  selectedDate,
  gameStartTime,
  deliveryStartTime,
  onPreOrdersClick,
  onEditClick,
  hasSchedule = false,
}) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        bgcolor: '#fff',
        p: 2,
        px: 3,
        border: '1px solid #e0e0e0',
        display: 'flex',
        alignItems: 'center',
        gap: 3,
        flexWrap: 'wrap',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          padding: '8px 14px',
          alignItems: 'center',
          gap: '8px',
          borderRadius: '8px',
          border: '1px solid var(--Gray-300, #D0D5DD)',
          background: 'var(--Base-White, #FFF)',
          boxShadow: '0 1px 2px 0 rgba(16, 24, 40, 0.05)',
        }}
      >
        <Typography fontSize="16px" fontWeight={600} color="#344054" lineHeight="24px">
          {selectedDate?.format('MMM DD, YYYY') || ''}
        </Typography>
      </Box>

      {hasSchedule && (
        <>
          <TimeBox label={t(LANG_TEXT.GAME_STARTS)} value={gameStartTime} />
          <TimeBox label={t(LANG_TEXT.DELIVERY_STARTS)} value={deliveryStartTime} />
        </>
      )}
      <Button
        id="edit_schedule_button"
        fullWidth={false}
        title={`${t(`${LANG_TEXT.EDIT}`)}`}
        buttonStyle={ButtonStyle('#30893C')}
        sxTextStyle={{ color: '#fff', fontWeight: 600, fontSize: 14 }}
        boxStyle={{ width: 'max-content !important' }}
        onClick={async (e) => {
          onEditClick();
          e.stopPropagation();
        }}
      />

      <Box sx={{ flex: 1 }} />

      {/* <Button
        id="preorder_button"
        fullWidth={false}
        title={`${t(`${LANG_TEXT.PRE_ORDERS}`)}`}
        buttonStyle={ButtonStyle('#FFF')}
        sxTextStyle={{ color: '#344054', fontWeight: 600, fontSize: 14 }}
        boxStyle={{ width: 'max-content !important' }}
        onClick={async (e) => {
          onPreOrdersClick();
          e.stopPropagation();
        }}
      /> */}
    </Box>
  );
};
